import React, { Component, Fragment } from 'react';
import { Form } from 'semantic-ui-react';
import mapConnection from '../../utils/connectionMapper'
import { AllAirlines } from '../../queries/AllAirlines'
import { compose, withApollo, graphql } from 'react-apollo';
import debounce from 'lodash.debounce';
import cancellablePromise from '../../utils/cancellablePromise';

class AirlineDropdown extends Component {
  state = {}

  debounce = debounce((filterString) => {
    if (this.cancelPrevPromise) {
      this.cancelPrevPromise();
    }
    this.setState({ loading: true })

    const { cancel, promise } = cancellablePromise(
      this.props.client.query({
        query: AllAirlines,
        variables: {
          autoComplete: {
            nameOrIata: filterString
          }
        },
        options: (props) => ({ fetchPolicy: 'cache-first' })
      })
    )
    this.cancelPrevPromise = cancel

    promise
      .then(({ data }) => data && this.setState({ codes: mapConnection(data.airlinesConnection), loading: false }))
      .catch((error) => this.setState({ loading: false }))

  }, 250)

  handleChange = (e) => {
    const filterString = e.target.value;
    this.debounce(filterString)
  }

  render = () => {
    const airlineData = this.state.codes
      ? this.state.codes
      : this.props.Airlines ? mapConnection(this.props.Airlines.airlinesConnection) : null
    const airlineOptions = airlineData
      ? airlineData.map((airline, i) => {
        const value = this.props.optionsValue === 'name' ? airline.name : airline.iata
        return {
          key: i,
          value: value,
          text: `${airline.name} (${airline.iata})`
        }
      }
    )
    : []
    const loading = this.state.loading || (this.props.Airlines && this.props.Airlines.loading)
    return (
      <Fragment>
        <Form.Dropdown
          fluid
          selection
          search={(a) => {return a}}
          multiple={this.props.multiple}
          options={airlineOptions}
          name="airline"
          label={this.props.labelled ? "Airline" : null}
          placeholder={this.props.placeholder ? "Airline" : null}
          value={this.props.value}
          onChange={this.props.onChange}
          onSearchChange={this.handleChange}
          onBlur={this.props.onBlur && this.props.onBlur.bind(this, 'airline')}
          loading={loading}
        />
      </Fragment>
    )
  }
}

const AirlineDropdownWithData = compose(
  withApollo,
  graphql(AllAirlines, {
    name: 'Airlines',
    skip: (props) => !props.value,
    options: (props) => ({
      variables: {
        filter: {
          iatas: props.value
        }
      },
      fetchPolicy: "cache-first"
    })
  })
)(AirlineDropdown);

export default AirlineDropdownWithData;



// WEBPACK FOOTER //
// ./src/component/dropdowns/AirlineDropdown.js